<template>
  <div class="right">
    <!-- 右侧菜单弹出 -->
    <van-popup
      id="popMenu"
      closeable
      v-model="rightMenuShow"
      position="right"
      close-icon-position="top-right"
      @close="menuClose"
    >
      <div class="header-con">
        <div class="popMenuLogo">
          <img src="../../assets/img/header/logo.png" />
        </div>
        <div class="menuItem">
          <div class="item" @click="menuClose">
            <router-link to="/" class="text"><div>低代码PaaS平台</div></router-link>
            <van-divider />
          </div>
          <div class="item" @click="productOpen">
            <div style="color: #000;font-size: 15px;padding-bottom: 20px;border-bottom: 1px solid #ebedf0">产品
              <img src="../../assets/img/header/up-arr.png" id="arr">
            </div>
          </div>
          <div class="item2 allProductButton" @click="menuClose">
            <router-link to="/allproductphone"><div style="padding-top: 17px;line-height: 10px">查看所有产品 >></div></router-link>
            <van-divider />
          </div>
          <div class="item2" @click="menuClose">
            <router-link to="/lowcodephone" class="text"><div>低代码开发平台</div></router-link>
            <van-divider />
          </div>
          <div class="item2" @click="menuClose">
            <router-link to="/nocodephone" class="text"><div>零代码开发平台</div></router-link>
            <van-divider />
          </div>
          <div class="item2" @click="menuClose">
            <router-link to="/ipaasphone" class="text"><div>融合集成平台（iPaaS）</div></router-link>
            <van-divider />
          </div>
          <div class="item2" @click="menuClose">
            <router-link to="/portalphone" class="text"><div>统一门户平台</div></router-link>
            <van-divider />
          </div>
          <div class="item2" @click="menuClose">
            <router-link to="/bpmphone" class="text"><div>工作流平台</div></router-link>
            <van-divider />
          </div>
          <div class="item2" @click="menuClose">
            <router-link to="/keyfeaturesphone" class="text"><div>智能服务</div></router-link>
            <van-divider />
          </div>
          <div class="item2" @click="menuClose">
            <router-link to="/keyfeaturesphone" class="text"><div>关键特性</div></router-link>
            <van-divider />
          </div>
          <div class="item2" @click="menuClose">
            <router-link to="/keyfeaturesphone" class="text"><div>支撑体系</div></router-link>
            <van-divider />
          </div>
          <div class="item" @click="menuClose">
            <router-link to="/CasePhonePage" class="text"><div style="margin-top: 15px">案例</div></router-link>
            <van-divider />
          </div>
          <div class="item" @click="menuClose">
            <router-link to="/DocumentPhonePage" class="text"><div>文档</div></router-link>
            <van-divider />
          </div>
          <div class="item" @click="menuClose">
            <router-link to="/FrontierPhonePage" class="text"><div>前沿</div></router-link>
            <van-divider />
          </div>
          <div class="item" @click="menuClose">
            <router-link to="/MallPhonePage" class="text"><div>商城</div></router-link>
            <van-divider />
          </div>
          <div class="item">
            <a class="text" href="http://www.jxdinfo.com/"><div>关于</div></a>
            <van-divider />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "RightMenu",
  props: {
    isMenuShow: Boolean,
  },
  data() {
    return {
      rightMenuShow: false,
      upArrBase64:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAANCAYAAABGkiVgAAAAAXNSR0IArs4c6QAAAcZJREFUOE+Nkz+LU1EQxc9J8p4hoLBi4SJaxcTkvQnCa+yWVWxstNgtrPxXLLaColjZLAT0EyyuYCPY7cp+ALexkCzhTrKFfgILC0HB5GlGr7wnsiZ5O929M+d3Zw5ziUNEHMeXSV4Pw3Ct1+ulRRIWFcRx3CK5TxJmpmEYJkXgudB2u32mUql8MLMjHprFdhAEK/PAM6FRFJ0sl8v7ABbM7HupVHpiZusAaGYbqnoXwM9pk06FNhqNE9VqdQ/AaQAe2On3+x9FpEvyfgbuquojAHYQ/B+0Xq8fq9VqbwGcBzAys2VVfZcLReQFyZv+/HuCh6ranQtNkqSWpukbABcBpGa2qqpbB0UiskPySnZ/wzn38t+av50mSRKMx+PXJK95ryaTydpgMHg+azs6nY7v/kKWv+qc285rc2hJRDZI3s48euCcezpv3XwTaZp632MAP8zskqrues0fqIg8I3kvg6w75x4X7a/PN5vNo2EY7pGsA/hmZkuq2qOI3CK5mRm/qap3DgPMa1qt1mIQBO8BnALwaTQanfXQVZKvAGw551amrUjRIyJyjuSumX32Py4ff0FVvwCYFAFm5aMoOg7g63A4HP8CDHCtM5MfbSEAAAAASUVORK5CYII=',
      downArrBase64:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAANCAYAAABGkiVgAAAAAXNSR0IArs4c6QAAAdRJREFUOE+dkj9oU1EUxr9zUkyUIBqwiwEHIwrv3RO0UoougQy6CG4iuDlqcdRBXATdi7vYQUQnF53aqRBQxOTeF59dpILoFJ1E4fJyzG1fin/yGvWbDvee73fv+UPGmP0ArqvqgyRJUvynROQyAG+tXSZjzA0iugvgo/f+VJqm7/+Va4y5SkRLwee9P0giclRVXxDRXgAbWZbN9fv9z38LjuP4EjPfBzCjqk+dc+cpmKMoOs3MK6Mfl1X1TbVaPdnpdL5NA4vIuZH9CYAygDUAZ621XzehQc1m84yqPgdAqvrSObcAYFgEFpFwvwJgDwCXZVlrXOE2NJhF5CKAhzlo1VrbngSNoqjBzK/yln3w3s+nafppnPsLNBzGcbzIzJtNB/DIWhse2paIzAJYB7APwBdmPtHtdjd+zvkDmrfitqreDLGq3nPOLYa4Xq/vrtVqYTsOqOp3AMedc29/r2YiFAAbY5aI6MoWV2855+6IyDsAh8IZEc31er3Xk9pTBEWr1ZoZDAbLRBTKD+B1IjqWQ9rW2tWiIRZC81XbVSqVnqlqm2grdTgcXkiS5PFO67YjNBgbjUa5Uqn0mfnwaDDXrLXjIRZyp0JzJ4vIkdEmhKlP1Q9zSK+iHDKphQAAAABJRU5ErkJggg==',
    };
  },
  methods: {
    menuClose() {
      this.$emit("rightMenuShow");
    },
    productOpen() {
      var arr = document.getElementById('arr');
      let item2 = document.querySelectorAll('div[class^="item2"]');

      if(item2[0].style.display!=='none'){
        item2.forEach((item) => item.style.display = 'none');
        arr.src=this.downArrBase64;
      }else {
        item2.forEach((item) => item.style.display = 'block');
        arr.src=this.upArrBase64;
      }
    }
  },
  watch: {
    isMenuShow() {
      this.rightMenuShow = this.isMenuShow;
    },
  }
};
</script>
<style scoped>
/* 弹出右侧菜单 */
#popMenu {
  height: 100%;
  width: 60%;
  margin: 0;
  z-index: 2000;
}
.header-con .popMenuLogo {
  color: #2e2e2e;
}
/* logo */
.popMenuLogo {
  float: left;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  padding: 20px;
}
.popMenuLogo img {
  width: 88px;
  height: 29px;
}
.menuItem .item {
  margin-left: 20px;
}
.menuItem .item2 {
  margin-left: 20px;
}
.menuItem .item > .text {
  font-size: 15px;
  color: #000;
}
.menuItem .item2 > .text {
  font-size: 13px;
  color: #000;
}
.menuItem .item2 > .text > div{
  margin-left: 20px;
}
.allProductButton{
  background: #F6F6F6;
  color: #8D8D8D;
  margin-left: 0px !important;
  padding-left: 40px;
  font-size: 13px;
}
#arr{
  width: 15px;
  position: relative;
  left: 140px;
}
</style>



// WEBPACK FOOTER //
// src/components/include/RightMenu.vue